const routes = {
  users: "/users",
  invitations: "/invitations",
  my_company: "/my-company",
};

export default routes;
